import type { ChargerConnectivity, NetworkSubmissionCreateBody } from '@evi/shared';

/**
 * The Submit a Location POST body, built from the form's draft. Pure so the
 * payload can be tested without rendering the page.
 */
export interface SubmitLocationDraft {
  contactName: string;
  contactEmail: string;
  contactPhone: string;
  isFleetAdmin: boolean;
  name: string;
  street: string;
  city: string;
  state: string;
  zip: string;
  locType: string;
  fleetId: string;
  units: Array<{ identity: string; vendor: string; model: string; connectors: string[]; maxKw: string }>;
  /** Required: the form cannot save until one is chosen. */
  connectivity: ChargerConnectivity;
  siteClaim?: { country: string; lat: number; lng: number };
}

export function buildSubmitLocationBody(d: SubmitLocationDraft): NetworkSubmissionCreateBody {
  if (d.siteClaim && (!d.siteClaim.country.trim() || !Number.isFinite(d.siteClaim.lat) || !Number.isFinite(d.siteClaim.lng) || Math.abs(d.siteClaim.lat) > 90 || Math.abs(d.siteClaim.lng) > 180)) throw new Error('Choose the site country and a valid map pin.');
  return {
    contact: {
      name: d.contactName.trim(),
      email: d.contactEmail.trim(),
      phone: d.contactPhone.trim() || null,
      role: d.isFleetAdmin ? 'fleet_manager' : 'sales_partner',
    },
    location: {
      name: d.name.trim(),
      address: { street: d.street.trim(), city: d.city.trim(), state: d.state.trim(), zip: d.zip.trim(), ...(d.siteClaim ? { country: d.siteClaim.country.trim() } : {}) },
      ...(d.siteClaim ? { coordinates: { lat: d.siteClaim.lat, lng: d.siteClaim.lng } } : {}),
      type: d.locType as NetworkSubmissionCreateBody['location']['type'],
    },
    chargers: d.units.map((u) => ({
      identity: u.identity.trim(),
      vendor: u.vendor.trim() || null,
      model: u.model.trim() || null,
      connector_types: u.connectors as Array<'J1772' | 'NACS' | 'CCS1'>,
      max_power_kw: u.maxKw ? Number(u.maxKw) : null,
    })),
    connectivity: d.connectivity,
    fleetId: d.isFleetAdmin && d.fleetId ? d.fleetId : null,
  };
}
